import { Component, DestroyRef, ViewChild, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { UserService } from '../../../services/rnapi2-service/apis/api';
import { RnCommonId } from '../../../services/rnapi2-service/models/models';
import { ModalComponent } from '@rn-platform/frontend-shared-ui-common';
import { CopyActivationModalService } from './copy-activation-modal.service';

const loadingState = 'loading';
const copiedState = 'copied';
const loadingText = 'Loading...';

@Component({
  selector: 'app-copy-activation',
  templateUrl: './copy-activation.component.html',
  styleUrls: ['./copy-activation.component.scss'],
  standalone: false
})
export class CopyActivationComponent implements OnInit {
  private readonly userService = inject(UserService);

  state = loadingState;
  activationLink = 'Loading';
  fullName: string = '';
  @ViewChild('modalRef') modalComponent: ModalComponent;
  @ViewChild('copyLinkInput') copyLinkInput: any;
  private readonly copyActivationModalService = inject(CopyActivationModalService);
  private readonly destroyRef = inject(DestroyRef);


  ngOnInit(): void {
    this.copyActivationModalService.modalState$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      if (!data) return;
      let userId: number = 0;
      let organizationId: number = 0;
      let fullName: string = '';
      if (data?.config) {
        userId = data?.config.userID;
        organizationId = data?.config.organizationID;
        fullName = data?.config.userFullName;      
      }     
      if (data?.isOpen) {
        this.open(userId, organizationId, fullName);
      } else {
        this.close();
      }
    });
  }

  copy(): void {
    this.copyLinkInput?.nativeElement?.select();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    navigator.clipboard.writeText(this.activationLink).then(() => {
      this.state = copiedState;
      setTimeout(() => {
        this.state = '';
      }, 2000);
    });
  }

  open(userId: number, organizationId: number, fullName: string): void {
    this.activationLink = loadingText;
    this.state = loadingState;
    this.fullName = fullName;
    const payload: RnCommonId = {
      Id: userId?.toString() ?? '',
      AffectedOrganizationId: organizationId
    };
    this.userService.apiV2UsersGetactivationlinkPost(payload, 'response').subscribe((response) => {
      if (response.body.Success) {
        this.activationLink = response.body.data;
        this.state = '';
      }
    });
    this.modalComponent?.open();
  }

  close(): void {
    this.modalComponent?.close();
  }
}
